import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, var(--accent-color) 0%, var(--contrast-accent) 100%);
  color: var(--text-inverse);
`;

export const ErrorContent = styled.div`
  max-width: 600px;
  text-align: center;
  background: var(--background-secondary);
  opacity: 0.9;
  padding: 3rem;
  border-radius: 0;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

export const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  color: var(--error-color);
`;

export const ErrorTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const ErrorMessage = styled.p`
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  line-height: 1.6;
`;

export const ErrorDetails = styled.details`
  margin: 2rem 0;
  text-align: left;
  background: rgba(0, 0, 0, 0.2);
  padding: 1rem;
  border-radius: 0;
  cursor: pointer;

  summary {
    font-weight: 600;
    margin-bottom: 0.5rem;
    cursor: pointer;
    user-select: none;
  }

  pre {
    font-size: 0.85rem;
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-top: 0.5rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
  background: ${props => props.primary ? 'var(--text-inverse)' : 'var(--background-secondary)'};
  opacity: ${props => props.primary ? '1' : '0.8'};
  color: ${props => props.primary ? 'var(--accent-color)' : 'var(--text-inverse)'};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;

// Update required container (special styling for chunk errors)
export const UpdateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, var(--warning-color) 0%, var(--warning-dark) 100%);
  color: var(--text-inverse);
`;

export const UpdateContent = styled.div`
  max-width: 500px;
  text-align: center;
  background: var(--background-primary);
  padding: 3rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`;

export const UpdateIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  color: var(--warning-color);
`;

export const UpdateTitle = styled.h1`
  font-size: 1.75rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: var(--text-primary);
`;

export const UpdateMessage = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
  color: var(--text-secondary);
  line-height: 1.6;
`;

export const CountdownText = styled.p`
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-top: 1rem;
`;

export const UpdateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
  background: var(--warning-color);
  color: var(--text-inverse);
  width: 100%;

  &:hover {
    background: var(--warning-dark);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }
`;
